<template>
  <v-container fluid grid-list>
    <v-layout row wrap class="app-list">
      <v-flex lg3 md4 sm6 xs12 v-for="app in apps" :key="`6${app.metaData.name}`" class="pa-4 app-item tiles">
        <div class="text-xs-center">
          <v-btn color="white" class="square" @click="goToApp(app.link)" :title="app.descriptions">
            <v-layout align-center justify-center column>
              <div class="app-icon-holder">
                <simple-svg
                  :filepath="iconPath(`${app.metaData.icon}`)"
                  :width="'100%'"
                  :height="'100%'"
                />
              </div>
              <h3 class="mt-2">{{ app.title }}</h3>
            </v-layout>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from "vuex";
  import * as API from "@/api/rest";

  const ROOT_ICONS = "//s3-ap-southeast-1.amazonaws.com/lms-prod-common-bucket/public";

  export default {
    props: {
      userRole: {
        type: String
      }
    },
    data() {
      return {
        apps: []
      }
    },
    methods: {
      iconPath(iconName) {
        return `${ROOT_ICONS}/${iconName}`;
      },
      goToApp(appLink) {
        const token = this.userAccountInformation.signInUserSession.accessToken.jwtToken;
        window.location.href = `${appLink}?token=${token}`;
      }
    },
    computed: {
      ...mapState('auth', ['userAccountInformation'])
    },
    async created() {
      this.apps = (await API.Get(`/app?relationId=techkids&id=1544814915334&role=${this.$props.userRole}`)).body.Items || [];
      // this.apps = [...this.apps,...this.apps,...this.apps]
    }
  }
</script>

<style>
  .app-list {
    padding-right: 0;
  }

  .text-xs-center {
    width: 100%;
    height: 100%;
  }

  .tiles:before {
    content:'';
    float:left;
    padding-top:100%;
  }

  .square {
    height: 70%;
    width: 70%;
    min-width: 120px;
    min-height: 120px;
    margin: 0;
  }

  .app-item {
    max-width: 450px;
    max-height: 450px;
  }

  .app-item .v-btn h3 {
    text-transform: none;
    font-weight: 400;
    font-size: 17px;
  }

  .app-icon-holder {
    max-width: 50px;
    max-height: 50px;
  }

  .app-icon-holder * {
    fill: var(--v-primary-base) !important;
    stroke: var(--v-primary-base) !important;
  }

  @media only screen and (min-width: 960px) {
    .app-list {
      padding-right: 15%;
    }
  }
</style>
